<template>
  <CSidebar
    class="sidebar-custom text-white"
    :visible="true"
  >
    <!-- Logo -->
    <CSidebarBrand class="sidebar-brand-custom text-white fs-4 text-start py-4 px-4 bg-transparent">
      <RouterLink to="/services" class="text-decoration-none text-white">
        <div class="sidebar-brand-custom-text changeling-text">PIPIT</div>
      </RouterLink>
    </CSidebarBrand>

    <!-- Navigation - cuộn khi vượt -->
    <CSidebarNav class="bg-transparent py-4">
      <SidebarNav />
      <!-- Footer -->
      <div class="border-top my-2 mx-4"></div>
      <!-- Footer -->
      <div class="sidebar-footer px-4 py-4 text-center text-white-50 bg-transparent">
        <p class="mb-2 small text-white" :style="{ fontSize: fontSize + 'px' }">今月の配信済メッセージ数</p>
        <div class="progress-circle mb-5 mt-5" :style="{background: `conic-gradient(#FAFAFA ${progress}% , #CFEDE4 0%)`}">
          <div class="circle-content">
            <strong class="text-white">{{ currentValue }}</strong>
            <small class="text-white-50">/{{ maxValue }}</small>
          </div>
        </div>
        <CButton
          color="light"
          class="w-100 bg-white d-flex align-items-center justify-content-center p-text-primary p-btn-logout" @click="logout"
          :style="{
            'font-size': '18px',
            'border-radius': '25px',
          }">
          <span class="me-2">ログアウト</span>
          <img :src="iconCilUserColorSrc" alt="Icon" class="text-black"/>
        </CButton>
      </div>
    </CSidebarNav>
  </CSidebar>
</template>

<script setup>
import {
  CSidebar,
  CSidebarBrand,
  CButton, CSidebarNav
} from '@coreui/vue'
import SidebarNav from "@/components/base/SidebarNav.vue";
</script>

<script>
import router from "@/router";
import store from "@/store";
import {onMounted, ref} from 'vue';
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const lineMessageRepository = RepositoryFactory.get('lineMessage');


// Import Vue Router
export default {
  data() {
    const fontSize = ref(16); // Default font size
    const currentValue = ref(0); // Initialize with 0
    const maxValue = ref(5000); // Default max value
    const progress = ref(0); // Initialize progress
    return {
      // Path to your SVG image file
      iconCilUserColorSrc: require('@/assets/icons/cil-user-color.svg'),
      fontSize,
      currentValue,
      maxValue,
      progress,
    };
  },
  methods: {
    // Logout function
    logout() {
      // remove all local storage
      localStorage.clear()
      store.commit("admin/logout")
      router.push({path: '/pages/login'})
    },
    async fetchCurrentValue() {
      // This function should return the current value dynamically
      const response = await lineMessageRepository.getLineInfo();
      return {
        currentValue: response.data.used || 0, // Adjust based on your API response structure
        maxValue: response.data.limit || 5000 // Adjust based on your API response structure
      }
    },
  },
  async mounted() {
    // TODO: Add any additional mounted logic if needed // Simulate fetching currentValue dynamically
    const {currentValue, maxValue} = await this.fetchCurrentValue();
    this.currentValue = currentValue; // Update current value
    this.maxValue = maxValue; // Update max value
    this.progress = (currentValue / maxValue) * 100; // Update progress
  }
};
</script>

<style>
.changeling-text {
  font-family: 'Changeling Neo', sans-serif;
  letter-spacing: 10px;
  font-weight: bold;
}

html:not([dir=rtl]) .sidebar:not(.sidebar-end) {
  margin: 20px;
}

.sidebar-custom {
  --cui-sidebar-width: 18.75em;
  background: #5EB093;
  color: white;
  border: 1px solid transparent; /* Makes the border transparent */
  border-radius: 15px;
}

.sidebar-custom .sidebar-brand-custom {
  justify-content: start;
}

.sidebar-custom .sidebar-brand-custom-text {
  font-size: 38.14px;
}

.progress-circle {
  width: 150px;
  height: 150px;
  margin: 0 auto;
  border-radius: 50%;
  background: conic-gradient(#5EB093 25%, #CFEDE4 0%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle-content {
  background-color: #5EB093;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.p-btn-logout:hover {
  background-color: #E0F2F1 !important;
  color: #5EB093 !important;
  border: none !important;
}
</style>
